"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TIMEZONE_OFFSET_PATTERN = new RegExp("^\\s*(?:(?:GMT|UTC)\\s?)?([+-])(\\d{1,2})(?::?(\\d{2}))?", "i");
var TIMEZONE_OFFSET_SIGN_GROUP = 1;
var TIMEZONE_OFFSET_HOUR_OFFSET_GROUP = 2;
var TIMEZONE_OFFSET_MINUTE_OFFSET_GROUP = 3;

var ExtractTimezoneOffsetRefiner = /*#__PURE__*/function () {
  function ExtractTimezoneOffsetRefiner() {
    _classCallCheck(this, ExtractTimezoneOffsetRefiner);
  }

  _createClass(ExtractTimezoneOffsetRefiner, [{
    key: "refine",
    value: function refine(context, results) {
      results.forEach(function (result) {
        if (result.start.isCertain("timezoneOffset")) {
          return;
        }

        var suffix = context.text.substring(result.index + result.text.length);
        var match = TIMEZONE_OFFSET_PATTERN.exec(suffix);

        if (!match) {
          return;
        }

        context.debug(function () {
          console.log("Extracting timezone: '".concat(match[0], "' into : ").concat(result));
        });
        var hourOffset = parseInt(match[TIMEZONE_OFFSET_HOUR_OFFSET_GROUP]);
        var minuteOffset = parseInt(match[TIMEZONE_OFFSET_MINUTE_OFFSET_GROUP] || "0");
        var timezoneOffset = hourOffset * 60 + minuteOffset;

        if (match[TIMEZONE_OFFSET_SIGN_GROUP] === "-") {
          timezoneOffset = -timezoneOffset;
        }

        if (result.end != null) {
          result.end.assign("timezoneOffset", timezoneOffset);
        }

        result.start.assign("timezoneOffset", timezoneOffset);
        result.text += match[0];
      });
      return results;
    }
  }]);

  return ExtractTimezoneOffsetRefiner;
}();

exports.default = ExtractTimezoneOffsetRefiner;